import React, { useEffect, useState } from "react";

// react-slick files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import General from "../../stores/GeneralStore";
// css
import "./Carousel.css";

// img svg

import BoxClockIcon from "../../assets/Home/BoxClockIcon.svg";
import TickIcon from "../../assets/Home/TickIcon.svg";
import ListIcon from "../../assets/Home/ListIcon.svg";
import BoxArrowIcon from "../../assets/Home/BoxArrowIcon.svg";
import NullFolderIcon from "../../assets/Home/NullFolderIcon.svg";
import RefreshIcon from "../../assets/Home/RefreshIcon.svg";
import IIcon from "../../assets/Home/IIcon.svg";
import CrouselCard from "./CrouselCard";
import { observer } from "mobx-react";

// components
// import CrouselCard from "../Carousel/CrouselCard";

const Carousel1 = ({ data,setValue,setInnerValue }) => {
  const [language, setLanguage] = useState();

  useEffect(() => {
    const reciveLanguage = localStorage.getItem("LanguageChange");
    const reciveLanguage1 = JSON.parse(reciveLanguage);
    setLanguage(reciveLanguage1);
  },[]);

  const [fontSize, setFontSize] = useState(14);
  useEffect(() => {
    const storedFontSize = localStorage.getItem("fontSizeLocal");
    if (storedFontSize) {
      setFontSize(storedFontSize);
    }
  },[]);

  let settings = {
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 826,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className={General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode !="ARA"?"col-12 pl-0 pr-4":""}>
      <Slider {...settings}>
        {data &&
          data.map((element) => {
            return (
              <div className="pr-2">
                <CrouselCard setValue={setValue} setInnerValue={setInnerValue} element={element} />
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default observer(Carousel1);
